import { SelectTheme } from "@acin.reactjs/acin-ui/select";
import theme, { ComponentCSSStyle } from "@acin.reactjs/acin-ui/theme";
import merge from "lodash/merge";
import { DefaultTheme } from "styled-components";

const selectTheme = (): ComponentCSSStyle<SelectTheme> => ({
  variants: {
    selectNoOptions: {
      dropdownButton: {
        icon: {
          display: "none",
        },
      },
      clearButton: {
        root: {
          marginRight: "0px",
        },
      },
      endAdornment: {
        root: {
          gap: "0px",
        },
      },
    },
  },
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  tags: {
    optionsCollapsedInfo: {
      color: theme.palette.common.black,
    },
  },
});

export default selectTheme;

export const SelectTagCloseTheme = (customTheme: DefaultTheme) =>
  merge({}, customTheme, {
    components: {
      select: {
        tags: {
          tagClose: {
            display: "none",
          },
        },
      },
    },
  });
